import {
  changeLocale,
  injectIntl,
  IntlContextConsumer,
} from 'gatsby-plugin-intl'
import React, { Component } from 'react'
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
// import Link from 'gatsby-link';



class LanguageSwitcher extends Component {
    constructor(props) {
        super(props)
        const language = this.props.intl.locale ? this.props.intl.locale : "ja"
        this.state = {
            language: language,
        }
        this.onSelectLanguage = this.onSelectLanguage.bind(this);
    }

    onSelectLanguage(e) {
        if(e.target) {
            // this.setState({language: e.target.value})
            changeLocale(e.target.value)
        } else {
            changeLocale(e.value)
        }
    }

    render() {
        const languageNames = [
            { value: 'en', label: 'English' },
            { value: 'ja', label: '日本語' },
        ]

        const cur_language = languageNames.find(x => x.value == this.state.language).label

        // return (
        //   <IntlContextConsumer>
        //     {({ languages, language: currentLocale }) => (
        //     <div className="select_language_box_container">
        //         <span className="select_language_text"> { cur_language } </span>
        //         <select 
        //         aria-label="select language"
        //         className="select_language_box"
        //         value={this.state.language}
        //         onChange={this.onSelectLanguage}>
        //             { languageNames.map((lang, i) => {
        //                 return (
        //                     <option key={lang.value} value={lang.value} >
        //                         {lang.label}
        //                     </option>
        //                 )
        //             })}
        //         </select>
        //     </div>
        //     )}
        //   </IntlContextConsumer>
        // )
        return (
            <IntlContextConsumer>
            {({ languages, language: currentLocale }) => (
                <Dropdown 
                    className="languageDrowdown"
                    controlClassName="languageControllDrowdown"
                    menuClassName="languageMenuDrowdown"
                    options={languageNames} 
                    onChange={this.onSelectLanguage}
                    placeholder={ cur_language }
                    arrowClassName="languageArrowClass"
                />
            )}
            </IntlContextConsumer>
        )
    }
}

export default injectIntl(LanguageSwitcher)
